/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Minus': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<rect pid="0" x="24.5" y="12.4" width="3" height="21" rx="1.5" transform="rotate(90 24.5 12.4)"/>'
  }
})
